import { API_NAMES, initApi } from "@usas/ui-web/utils/HttpApiHelper";
import { BASIC_INITIAL_STATE } from "@usas/ui-web/utils/HttpHelper";

const getNTRegistrationPersonData = (personId, state, setState) => {
  const api = initApi(API_NAMES.PERSON, state, setState);

  const personIdForUrl = personId ? encodeURIComponent(personId) : 0;
  const url = `/Person/${personIdForUrl}/nationalteam`;

  return api.executeObject ? api.executeObject(url, 'GET') : null;
};

const putNTRegistrationPersonData = (personId, personNTObj, state, setState) => {
  if (personNTObj) {
    const api = initApi(API_NAMES.PERSON, state, setState);

    const personIdForUrl = personId ? encodeURIComponent(personId) : 0;
    const url = `/Person/${personIdForUrl}/nationalteam`;

    return api.executeObject ? api.executeObject(url, 'PUT', personNTObj) : null;
  }
};

const INITIAL_NATIONAL_TEAM_REGISTRATION_PERSON_STATE = {
  ...BASIC_INITIAL_STATE
};

const NTRegistrationPersonData = {
  INITIAL_NATIONAL_TEAM_REGISTRATION_PERSON_STATE,
  getNTRegistrationPersonData,
  putNTRegistrationPersonData
};

export default NTRegistrationPersonData;